<template>
    <div class="bottle" @click="$emit('click')">
      <div class="bottleCard" :class="{smallCard: small}">
        <div class="imgSide">
          <img :src="image" :alt="title" />
        </div>
        <div class="contendSide">
          <div class="info">
            <div class="name"> {{ title }} </div>
            <div class="appelation" v-if="!isTasting"> {{ this.product.type }} </div>
            <div class="appelation" v-if="isTasting"> {{ this.product.naming }} </div>
            <div class="year"> {{ this.product.millesime }} </div>
            <div class="nomaineName"> {{ this.product.domainName }} </div>
          </div>
          <div class="btn" v-if="isTasting">
            <div class="starBox note" v-if="rating > 0" @click="goNote">
              <div v-for="n in 5" :key="n" class="oneStar">
                <img
                  v-if="rating >= n"
                  class="star"
                  alt="full star"
                  src="../../assets/fullStar.svg"
                />
                <img
                  v-else
                  class="star"
                  alt="full star"
                  src="../../assets/emptyStar.svg"
                />
              </div>
            </div>
            <div v-else class="note" @click="goNote">Noter</div>
            <div class="taste">deguster</div>
          </div>
        </div>
      </div>
      <div class="bottlePrice">
        <div class="price" v-if="price">{{ this.price }} €</div>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ProductBottleResponcive',
  props: {
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    price: {
      type: Number,
      required: false
    },
    promotionPrice: {
      type: Number,
      required: false
    },
    soldOut: {
      type: Boolean,
      required: false,
      default: false
    },
    contentfulId: {
      type: Object,
      required: false
    },
    ratingPath: {
      type: String,
      required: false
    },
    isTasting: {
      type: Boolean,
      required: true
    },
    bottleId: {
        type: String,
        required: false
    },
    small: {
      type: Boolean,
      required: false,
      default: false
    },
    rating: {
        type: Number,
        required: false
    },
  },
  computed: {
    ...mapGetters([
        'getBottleById'
    ]),
    product() {
      if (this.isTasting) {
        return this.getBottleById(this.bottleId)
      }
      return this.contentfulId
    },
  },
  methods: {
    goNote() {
      if (this.$route.path.includes("/theme/")) {
          localStorage.setItem('comingFromTasteThemeId', this.$route.params.themeId)
      }
      this.$router.push({ name: 'tasting-rating', params: { tastingId: this.ratingPath } })
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

// box 
.bottleCard {
  background-color: #DDE0F3;
  // box-shadow: 0px 3px 6px #B0B4CB;
  width: 400px;
  height: 300px;
  border-radius: 15px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  font-family: "Avenir", Helvetica;
  box-shadow: 0px 4px 6px #B0B4CB;
}

.imgSide {
  width: 40%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.contendSide {
  width: 60%;
  height: 100%;
}

// box //

// bottle information 
.info {
  padding-right: 5%;
  height: 60%;
  padding-top: 5%;
  text-align: left;
}

.name {
  font: normal normal 700 22px "Avenir", Helvetica;
  // margin-top: 25px;
  margin-bottom: 10px;
}

.btn {
  height: 35%;
  overflow: hidden;
  & > div {
    height: 30px;
    width: 60%;
    background-color: white;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    text-transform: uppercase;
    font: normal normal 700 14px "Avenir", Helvetica;
  }
}

.note {
  margin-bottom: 8px;
}

.starBox {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly !important;
  align-items: center;
  width: 100%;
}

.oneStar {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
}

// bottle information //

// price

.bottlePrice {
  width: 100%;
  display: flex;
  justify-content: center;
}

.price {
  background-color: #D10A4A;
  padding: 4px 25px;
  border-radius: 20px;
  color: white;
  font-weight: 600;
  font-size: 18px;
  margin-top: -18px;
}

// price //


@media screen and (max-width: 449px) {
  .bottleCard {
    height: 300px;
    width: 300px;
  }
  .name {
    margin-top: 15px;
    font: normal normal 700 17px "Avenir", Helvetica;
  }

  .btn > div {
    width: 90%;
  } 
}

.smallCard {
  width: 400px !important;
}

@media screen and (min-width: 1350px) {
  .bottleCard {
    width: 500px;
  }
}
</style>